// based on https://pages.github.schibsted.io/mpt-data/pulse-standard/#actor-object
import get from 'lodash/get.js';

import type { SessionData } from '../../../../../public-src/core/js/schibsted-account/types.js';

const WITHOUT_SUBSCRIPTION = 'No';
const ABO_SUBSCRIPTION = 'Abo';

const getActorSubscriptionName = (sessionData: SessionData): string => {
  const hasSubscription = get(sessionData, 'access.entitled');

  if (!hasSubscription) {
    return WITHOUT_SUBSCRIPTION;
  }

  return ABO_SUBSCRIPTION;
};

export { getActorSubscriptionName };
